import { ADD_TO_CONTEXT_MENU,
  TOGGLE_CONTEXT_MENU,
} from './music-actions';
export const addToContextMenu= (currentContent) => ({type: ADD_TO_CONTEXT_MENU, currentContent });
export const toggleContextMenu = () => ({type: TOGGLE_CONTEXT_MENU });



// WEBPACK FOOTER //
// ./src/actions/musica/context-menu-actions.js